import { c as _c } from "react/compiler-runtime";
import SvgStarFill from '@common/icon/SvgStarFill';
import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import { WEL_MARKET_ROUTES } from '@/constants/routes';
import { formatPrice } from '@/utils/formatPrice';
interface SearchMarketCardProps {
  productId?: string;
  imageUrl?: string;
  productName?: string;
  region?: string;
  originalPrice?: number;
  expectedFinalPrice?: number;
  discountRate?: number;
  rating?: number;
  reviewCount?: number;
}
export const SearchMarketCard = t0 => {
  const $ = _c(46);
  const {
    productId,
    imageUrl,
    productName,
    region,
    originalPrice,
    expectedFinalPrice,
    discountRate,
    rating,
    reviewCount
  } = t0;
  const regularPrice = originalPrice ?? 0;
  const finalPrice = expectedFinalPrice ?? regularPrice;
  const hasDiscount = finalPrice !== regularPrice;
  let t1;
  if ($[0] !== productId) {
    t1 = productId ? WEL_MARKET_ROUTES.PRODUCT_DETAIL.pathname({
      productNumber: productId
    }) : "#";
    $[0] = productId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const detailHref = t1;
  const t2 = `${productName ?? ""} 상세 페이지로 이동`;
  let t3;
  if ($[2] !== imageUrl || $[3] !== productName) {
    t3 = imageUrl ? <Image src={imageUrl} alt={productName ?? "\uC0C1\uD488 \uC774\uBBF8\uC9C0"} fill={true} sizes="(max-width: 1279px) 50vw, 25vw" className="object-cover" /> : <div className="size-full bg-Gray-100" />;
    $[2] = imageUrl;
    $[3] = productName;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== detailHref || $[6] !== t2 || $[7] !== t3) {
    t4 = <CustomLink href={detailHref} aria-label={t2} className="relative aspect-square w-full overflow-hidden rounded-xlarge">{t3}</CustomLink>;
    $[5] = detailHref;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== region) {
    t5 = region ? <p className="font-600 text-Gray-600 typo-body4">{region}</p> : null;
    $[9] = region;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== detailHref || $[12] !== productName) {
    t6 = productName ? <CustomLink href={detailHref} className="line-clamp-2 font-500 text-Gray-800 typo-body3">{productName}</CustomLink> : null;
    $[11] = detailHref;
    $[12] = productName;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== hasDiscount || $[15] !== regularPrice) {
    t7 = hasDiscount ? <span className="font-400 text-Gray-550 line-through typo-body4">{formatPrice(regularPrice)}</span> : null;
    $[14] = hasDiscount;
    $[15] = regularPrice;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== discountRate || $[18] !== hasDiscount) {
    t8 = hasDiscount && discountRate && discountRate > 0 ? <span className="font-700 text-R-400 typo-body2 mobile-tablet:typo-body3">{discountRate}%</span> : null;
    $[17] = discountRate;
    $[18] = hasDiscount;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== finalPrice) {
    t9 = formatPrice(finalPrice);
    $[20] = finalPrice;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t9) {
    t10 = <span className="font-700 text-Gray-black typo-body2 mobile-tablet:typo-body3">{t9}</span>;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t8) {
    t11 = <div className="flex flex-wrap items-baseline gap-x-4 gap-y-2">{t8}{t10}</div>;
    $[24] = t10;
    $[25] = t8;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t11 || $[28] !== t7) {
    t12 = <div className="flex flex-col gap-2">{t7}{t11}</div>;
    $[27] = t11;
    $[28] = t7;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <SvgStarFill className="size-16 text-Y-550" />;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  const t14 = rating ?? 0;
  let t15;
  if ($[31] !== t14) {
    t15 = <span className="font-700 text-Gray-600 typo-body3 mobile-tablet:typo-body4">{t14}</span>;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  const t16 = reviewCount ?? 0;
  let t17;
  if ($[33] !== t16) {
    t17 = <span className="font-400 text-Gray-600 typo-body3 mobile-tablet:typo-body4">({t16})</span>;
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t15 || $[36] !== t17) {
    t18 = <div className="flex items-center gap-4">{t13}<div className="flex items-center gap-2">{t15}{t17}</div></div>;
    $[35] = t15;
    $[36] = t17;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t12 || $[39] !== t18 || $[40] !== t5 || $[41] !== t6) {
    t19 = <div className="flex flex-col gap-8">{t5}{t6}{t12}{t18}</div>;
    $[38] = t12;
    $[39] = t18;
    $[40] = t5;
    $[41] = t6;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== t19 || $[44] !== t4) {
    t20 = <article className="flex flex-col gap-8">{t4}{t19}</article>;
    $[43] = t19;
    $[44] = t4;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  return t20;
};